import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import MobileStepper from "@material-ui/core/MobileStepper";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import StoreIcon from "@material-ui/icons/Store";
import { API, graphqlOperation } from "aws-amplify";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import Copyright from "../components/Auth/Copyright";
import Loading from "../components/Loading";
import SelectAddress from "../components/SelectAddress";
import SelectBanco from "../components/SelectBanco";
import SelectTipoCuenta from "../components/SelectTipoCuenta";
import {
  formatRut,
  generateSlug,
  nombreEsValido,
  rutEsValido,
  toTitleCase,
  unformatRut
} from "../functions";
import { getProspect } from "../graphql/queries";
import logger from "../logger";
import { signOut, checkSlugName } from "./App";

const useStyles = makeStyles(theme => ({
  root: {
    height: "100vh"
  },
  stepper: {
    flexGrow: 1
  },
  stepperProgress: {
    width: "100%"
  },
  paper: {
    margin: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  icons: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between"
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main
  },
  headerButton: {
    margin: theme.spacing(1),
    width: 40,
    height: 40
  },
  button: {
    margin: theme.spacing(6, 0, 2),
    borderRadius: "30px"
  },
  logo: {
    width: "65%",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4)
  }
}));

const Intro = ({ authData, usuario, onClompleted }) => {
  const classes = useStyles();

  const [fetchingProspecto, setFetchingProspecto] = useState(true);
  const [prospecto, setProspecto] = useState(null);

  const [tienda, setTienda] = useState("");
  const [tiendaError, setTiendaError] = useState("");

  const [slug, setSlug] = useState(null);

  const [celular, setCelular] = useState("");
  const [celularError, setCelularError] = useState("");

  const [direccion, setDireccion] = useState("");
  const [direccionError, setDireccionError] = useState("");

  const [rut, setRut] = useState("");
  const [rutError, setRutError] = useState("");

  const [titular, setTitular] = useState("");
  const [titularError, setTitularError] = useState("");

  const [banco, setBanco] = useState(null);
  const [bancoError, setBancoError] = useState("");

  const [tipoCuenta, setTipoCuenta] = useState(null);
  const [tipoCuentaError, setTipoCuentaError] = useState("");

  const [cuenta, setCuenta] = useState("");
  const [cuentaError, setCuentaError] = useState("");

  const [cuentaConfirm, setCuentaConfirm] = useState("");
  const [cuentaConfirmError, setCuentaConfirmError] = useState("");

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [activeStep, setActiveStep] = useState(0);
  const [buttonText, setButtonText] = useState("Continuar");

  useEffect(() => {
    const fetchProspecto = async email => {
      try {
        const vars = {
          email
        };

        const result = await API.graphql(graphqlOperation(getProspect, vars));

        if (result.data.getProspect) {
          setProspecto(result.data.getProspect);
          setFetchingProspecto(false);
        }
      } catch (err) {
        logger("Intro.fetchProspecto.error", err);
      }
    };

    if (authData && !usuario) {
      fetchProspecto(authData.attributes.email);
    }
  }, [authData, usuario]);

  const validarTienda = () => {
    let valid = true;
    let msg = "";

    const rgx = new RegExp(/^[a-zA-Z' áéíóúÁÉÍÓÚ-]+$/);

    if (!Boolean(tienda) || tienda.trim() === "") {
      valid = false;
      msg = "El nombre de la tienda es obligatorio";
    } else if (tienda.length < 3) {
      valid = false;
      msg = "El nombre de la tienda debe tener más de 3 caracteres";
    } else if (!rgx.test(tienda)) {
      valid = false;
      msg = "El nombre de la tienda debe contener solo caracteres alfanuméricos";
    }

    setTiendaError(msg);
    return valid;
  };

  const validarCelular = () => {
    let result = true;
    let msg = "";

    if (!Boolean(celular)) {
      result = false;
      msg = "El teléfono móvil es obligatorio";
    } else if (celular.length !== 8) {
      result = false;
      msg = "El teléfono móvil es inválido";
    }

    setCelularError(msg);
    return result;
  };

  const validarDireccion = () => {
    let result = true;
    let msg = "";

    if (!Boolean(direccion)) {
      result = false;
      msg = "La dirección es obligatoria";
    }

    setDireccionError(msg);
    return result;
  };

  const validarTitular = () => {
    let result = true;
    let msg = "";

    if (!Boolean(titular) || titular.trim() === "") {
      result = false;
      msg = "El nombre del titular es obligatorio";
    } else if (!nombreEsValido(titular.trim())) {
      result = false;
      msg = "El nombre de titular tiene caracteres no permitidos";
    }

    setTitularError(msg);
    return result;
  };

  const validarRut = () => {
    let result = true;
    let msg = "";

    if (!Boolean(rut)) {
      result = false;
      msg = "El rut es obligatorio";
    } else if (!rutEsValido(rut)) {
      result = false;
      msg = "Rut inválido";
    }

    setRutError(msg);
    return result;
  };

  const validarBanco = () => {
    let result = true;
    let msg = "";

    if (!Boolean(banco)) {
      result = false;
      msg = "El banco es obligatorio";
    }

    setBancoError(msg);
    return result;
  };

  const validarTipoCuenta = () => {
    let result = true;
    let msg = "";

    if (!Boolean(tipoCuenta)) {
      result = false;
      msg = "El tipo de cuenta es obligatorio";
    }

    setTipoCuentaError(msg);
    return result;
  };

  const validarCuenta = () => {
    let result = true;
    let msg = "";

    if (!Boolean(cuenta)) {
      result = false;
      msg = "El número de cuenta es obligatorio";
    }

    setCuentaError(msg);
    return result;
  };

  const validarCuentaConfirm = () => {
    let result = true;
    let msg = "";

    if (!Boolean(cuentaConfirm)) {
      result = false;
      msg = "El número de cuenta es obligatorio";
    } else if (cuentaConfirm !== cuenta) {
      result = false;
      msg = "El número de cuenta no coincide";
    }

    setCuentaConfirmError(msg);
    return result;
  };

  const tiendaChange = ({ target }) => {
    const slug = generateSlug(target.value.trim());
    setTienda(target.value);
    setSlug(slug);
  };

  const onBack = () => {
    let current = activeStep;
    if (current === 2) setButtonText("Continuar");
    if (current > 0) setActiveStep(current - 1);
  };

  const onNext = () => {
    let current = activeStep;
    if (current === 0) onStoreNext();
    else if (current === 1) {
      setButtonText("Crear Tienda");
      onContactNext();
    } else if (current === 2) onCreate();
  };

  const onStoreNext = async () => {
    setLoading(true);
    if (validarTienda()) {
      const result = await checkSlugName(slug);

      if (result) {
        setTiendaError("");
        setActiveStep(1);
      } else {
        setTiendaError("Prueba otro nombre, este ya está en uso");
      }
    }

    setLoading(false);
  };

  const onContactNext = () => {
    if (validarCelular() && validarDireccion()) {
      setCelularError("");
      setDireccionError("");
      setActiveStep(2);
    }
  };

  const onCreate = async () => {
    try {
      setLoading(true);

      if (
        validarTitular() &&
        validarRut() &&
        validarBanco() &&
        validarTipoCuenta() &&
        validarCuenta() &&
        validarCuentaConfirm()
      ) {
        if (checkSlugName()) {
          setErrorMessage("");

          const init = {
            body: {
              usuario: {
                email: prospecto.email,
                userId: authData.attributes.sub,
                nombre: prospecto.firstname,
                apellido: prospecto.lastname
              },
              tienda: {
                nombre: tienda.trim(),
                slug,
                datos: {
                  direccion,
                  telefono: celular,
                  recaudacion: {
                    titular: titular.trim(),
                    rut,
                    banco,
                    tipoCuenta,
                    cuenta: cuenta.padStart(8, "0")
                  }
                }
              }
            }
          };

          const result = await API.post(process.env.REACT_APP_HUB_API, "/tienda", init);

          if (result.success) {
            onClompleted();
            window.location.href = "/";
          } else {
            setErrorMessage("Occurió un problema");
            logger("Intro.crear.warning", result);
          }
        } else {
          setErrorMessage("Prueba otro nombre de tienda, el que elegiste ya fue usado");
        }
      }
    } catch (err) {
      logger("Intro.crear.error", err);
      setErrorMessage("Occurió un problema");
    } finally {
      setLoading(false);
    }
  };

  if (usuario) {
    window.location.href = "/";
    return null;
  }

  if (fetchingProspecto) {
    return <Loading show />;
  }

  const renderStep = () => {
    switch (activeStep) {
      case 0:
        return renderStoreStep();
      case 1:
        return renderContactStep();
      case 2:
        return renderBankStep();
      default:
        return <></>;
    }
  };

  const renderStoreStep = () => (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h6" className="mt-2" align="center">
          Nombre de tu tienda
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center">
          Es el nombre con el cual tus clientes reconocerán tu tienda
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          fullWidth
          label="Tienda"
          placeholder="El nombre de tu tienda"
          disabled={loading}
          value={tienda}
          onBlur={validarTienda}
          onChange={tiendaChange}
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{
            maxLength: 45
          }}
          error={Boolean(tiendaError)}
          helperText={tiendaError}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary" align="center">
          El link que ocuparán tus clientes se verá así
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          required
          fullWidth
          label="URL"
          disabled={true}
          value={"https://app.carritofacil.cl/" + generateSlug(tienda)}
        />
      </Grid>
    </Grid>
  );

  const renderContactStep = () => (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h6" className="mt-2" align="center">
          Datos de contacto
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center">
          Necesitamos algunos datos para poder contactarte
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <NumberFormat
          customInput={TextField}
          required
          fullWidth
          format="+56 9 #### ####"
          allowEmptyFormatting
          type="tel"
          label="Teléfono móvil"
          placeholder="¿Cuál es tu teléfono móvil?"
          InputLabelProps={{
            shrink: true
          }}
          value={celular}
          disabled={loading}
          onValueChange={({ value }) => setCelular(value)}
          onBlur={validarCelular}
          error={Boolean(celularError)}
          helperText={celularError}
        />
      </Grid>

      <Grid item xs={12}>
        <SelectAddress
          required
          label="Dirección"
          placeholder="¿Dónde está ubicada tu tienda?"
          disabled={loading}
          value={direccion}
          onChange={place => setDireccion(place)}
          onBlur={validarDireccion}
          error={Boolean(direccionError)}
          helperText={direccionError}
        />
      </Grid>
    </Grid>
  );

  const renderBankStep = () => (
    <Grid container spacing={3}>
      {errorMessage && (
        <Grid item xs={12} className="my-2">
          <Typography color="error" align="center" variant="body2">
            {errorMessage}
          </Typography>
        </Grid>
      )}

      <Grid item xs={12}>
        <Typography variant="h6" className="mt-2" align="center">
          Cuenta bancaria
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center">
          ¿Por qué necesitas una cuenta bancaria?
          <br />
          Depositaremos ahí la recaudación de tus ventas en línea.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          fullWidth
          label="Nombre del titular"
          disabled={loading}
          value={titular}
          onChange={({ target }) => setTitular(toTitleCase(target.value))}
          onBlur={validarTitular}
          error={Boolean(titularError)}
          helperText={titularError}
          inputProps={{
            maxLength: 50
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          required
          fullWidth
          label="Rut del titular"
          disabled={loading}
          value={formatRut(rut)}
          onChange={({ target }) => setRut(unformatRut(target.value))}
          onBlur={validarRut}
          inputProps={{
            maxLength: 12
          }}
          error={Boolean(rutError)}
          helperText={rutError}
        />
      </Grid>

      <Grid item xs={12}>
        <SelectBanco
          required
          variant="standard"
          disabled={loading}
          value={banco}
          onChange={value => setBanco(value)}
          onBlur={validarBanco}
          error={Boolean(bancoError)}
          helperText={bancoError}
        />
      </Grid>

      <Grid item xs={12}>
        <SelectTipoCuenta
          required
          variant="standard"
          disabled={loading}
          value={tipoCuenta}
          onChange={value => setTipoCuenta(value)}
          onBlur={validarTipoCuenta}
          error={Boolean(tipoCuentaError)}
          helperText={tipoCuentaError}
        />
      </Grid>

      <Grid item xs={12}>
        <NumberFormat
          customInput={TextField}
          required
          fullWidth
          label="Número de cuenta"
          value={cuenta}
          disabled={loading}
          onValueChange={({ value }) => setCuenta(value)}
          onBlur={validarCuenta}
          error={Boolean(cuentaError)}
          helperText={cuentaError}
        />
      </Grid>

      <Grid item xs={12}>
        <NumberFormat
          customInput={TextField}
          required
          fullWidth
          label="Confirmar número de cuenta"
          value={cuentaConfirm}
          disabled={loading}
          onValueChange={({ value }) => setCuentaConfirm(value)}
          onBlur={validarCuentaConfirm}
          error={Boolean(cuentaConfirmError)}
          helperText={cuentaConfirmError}
        />
      </Grid>
    </Grid>
  );

  return (
    <Container maxWidth="sm" className={classes.root}>
      <MobileStepper
        variant="progress"
        steps={3}
        position="static"
        activeStep={activeStep}
        className={classes.stepper}
        LinearProgressProps={{ className: classes.stepperProgress }}
      />
      <div className={classes.paper}>
        <div className={classes.icons}>
          {activeStep > 0 ? (
            <Tooltip title="Volver">
              <IconButton className={classes.headerButton} onClick={onBack}>
                <ArrowBackIosIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <div className={classes.headerButton} />
          )}
          <Avatar className={classes.avatar}>
            <StoreIcon />
          </Avatar>
          <Tooltip title="Cerrar sesión">
            <IconButton className={classes.headerButton} onClick={signOut}>
              <PowerSettingsNewIcon />
            </IconButton>
          </Tooltip>
        </div>

        <img
          className={classes.logo}
          src={process.env.PUBLIC_URL + "/assets/images/home_logo.png"}
          alt="home-logo"
        />

        {renderStep()}
        <Button
          fullWidth
          size="large"
          variant="contained"
          color="secondary"
          className={classes.button}
          onClick={onNext}
        >
          {loading ? <CircularProgress size={25} /> : buttonText}
        </Button>
      </div>
      <Box mt={4} mb={2}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default Intro;
